// Turbo replaces the body but retains the html element. Synchronize the root
// before rendering so native controls and DataTables receive the saved mode.
document.addEventListener("turbo:before-render", (event) => {
  const theme = event.detail.newBody.dataset.coreuiTheme || "light";
  document.documentElement.dataset.coreuiTheme = theme;
  document.documentElement.dataset.bsTheme = theme;
});
